import { ReactNode } from 'react';
import styled from 'styled-components';

interface Props {
  children: ReactNode;
}

export function InfoBoxQuoteText(props: Props) {
  return <Root>&ldquo;{props.children}&rdquo;</Root>;
}

const Root = styled.span``;
